/* unplugin-vue-components disabled */import script from "./IntegralTravelPrice.vue?vue&type=script&setup=true&lang=jsx"
export * from "./IntegralTravelPrice.vue?vue&type=script&setup=true&lang=jsx"

import "./IntegralTravelPrice.vue?vue&type=style&index=0&id=c6fda5ba&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6fda5ba"]])

export default __exports__